export const groupBy = (array, keyFn) => {
    return array.reduce((result, item) => {
        const key = typeof keyFn === 'function' ? keyFn(item) : item[keyFn];
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
        return result;
    }, {});
}

export const isNotEmptyObject = (obj) => typeof obj === 'object' && !!Object.keys(obj).length